import { TIENDANUBE_AUTHORIZATION_KEY_PREFIX } from './tiendanube/storage';

export const retainedAuthorizationPrefixes = [TIENDANUBE_AUTHORIZATION_KEY_PREFIX];
